import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState } from "react";

export default function PaymentCheckPhase(props) {
    const setProgress = props.setProgress;
    const newStudentData = props.newStudentData;
    const setNewStudentData = props.setNewStudentData;
    const groupData = props.groupData;
    const formConfig = props.formConfig;

    // Determine the correct back step based on centralized config
    const getBackStep = () => {
        if (formConfig.hasPaymentUrl) {
            return 5; // Go back to payment link step
        } else {
            return 4; // Go back to parents details step
        }
    };

    // Determine the correct next step based on centralized config
    const getNextStep = () => {
        if (formConfig.hasPaymentUrl && formConfig.hasPaymentCheck) {
            return 7; // Go to details approve step (after payment check)
        } else if (!formConfig.hasPaymentUrl && formConfig.hasPaymentCheck) {
            return 6; // Go to details approve step (after payment check)
        } else {
            return 6; // Fallback
        }
    };

    const [invoiceNumber, setInvoiceNumber] = useState(
        newStudentData.paymentCheckData?.InvoiceString || ""
    );
    const [invoiceNumberTouched, setInvoiceNumberTouched] = useState(false);
    const [invoiceNumberValid, setInvoiceNumberValid] = useState(true);

    const [creditCardDigits, setCreditCardDigits] = useState(
        newStudentData.paymentCheckData?.creditCardDigits || ""
    );
    const [creditCardDigitsTouched, setCreditCardDigitsTouched] = useState(false);
    const [creditCardDigitsValid, setCreditCardDigitsValid] = useState(true);

    return (
        <div className="contentContainer">
            <h2 className="text-center mb-4">אימות תשלום</h2>
            <p className="text-center mb-4" style={{ color: '#666', fontSize: '0.9rem' }}>
                לאחר ששילמתם בעבור הפעילות של הקבוצה, הזינו את הפרטים.
            </p>
            <Form className="formStyles">
                <Form.Group className="mb-3">
                    <Form.Control
                        type="text"
                        className="newtext newsmallerText newblackText formField parentField"
                        placeholder="מספר חשבונית"
                        value={invoiceNumber}
                        id="invoiceNumber"
                        style={{ fontFamily: 'Open Sans', width: '300px', fontWeight: 'normal' }}
                        onChange={(e) => {
                            setInvoiceNumber(e.target.value);
                        }}
                        onBlur={() => {
                            if (!invoiceNumberTouched) setInvoiceNumberTouched(true);
                            if (invoiceNumber.trim().length > 0) setInvoiceNumberValid(true);
                            else setInvoiceNumberValid(false);
                        }}
                        isInvalid={!invoiceNumberValid}
                    />
                    <Form.Control
                        type="text"
                        className="formField"
                        placeholder="4 ספרות אחרונות של כרטיס אשראי"
                        value={creditCardDigits}
                        id="creditCardDigits"
                        style={{ fontFamily: 'Open Sans', fontWeight: 'normal' }}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                            setCreditCardDigits(value);
                        }}
                        onBlur={() => {
                            if (!creditCardDigitsTouched) setCreditCardDigitsTouched(true);
                            if (creditCardDigits.length === 4) setCreditCardDigitsValid(true);
                            else setCreditCardDigitsValid(false);
                        }}
                        isInvalid={!creditCardDigitsValid}
                    />
                </Form.Group>
            </Form>
            <div className="form-actions">
                <Button
                    variant="secondary"
                    className="newtext newsmallerText"
                    onClick={() => {
                        setNewStudentData({
                            ...newStudentData,
                            paymentCheckData: {
                                InvoiceString: invoiceNumber,
                                creditCardDigits: creditCardDigits
                            }
                        });
                        setProgress(getBackStep());
                    }}
                >
                    חזור
                </Button>
                <Button
                    variant="primary"
                    className="newtext newsmallerText btn btn-primary"
                    onClick={() => {
                        setNewStudentData({
                            ...newStudentData,
                            paymentCheckData: {
                                InvoiceString: invoiceNumber,
                                creditCardDigits: creditCardDigits
                            }
                        });
                        setProgress(getNextStep());
                    }}
                    disabled={
                        !(
                            creditCardDigits.trim().length === 4 &&
                            invoiceNumber.trim().length > 0
                        )
                    }
                >
                    המשך
                </Button>
            </div>
        </div>
    );
} 